/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    CLIENT_ADDED_TO_OFFICE: 'CLIENT_ADDED_TO_OFFICE',
    CLIENT_ADDED_TO_OFFICE_BY_STUDIO: 'CLIENT_ADDED_TO_OFFICE_BY_STUDIO',
    CLIENT_ORDER_CREATED_BY_CLIENT: 'CLIENT_ORDER_CREATED_BY_CLIENT',
    CLIENT_ORDER_CREATED_BY_STUDIO: 'CLIENT_ORDER_CREATED_BY_STUDIO',
    CLIENT_CREDIT_ADDED_BY_STUDIO: 'CLIENT_CREDIT_ADDED_BY_STUDIO',
    CLIENT_PASS_ADDED_BY_STUDIO: 'CLIENT_PASS_ADDED_BY_STUDIO',
    CLIENT_WORKSHOP_ORDER: 'CLIENT_WORKSHOP_ORDER',
    CLIENT_COURSE_ORDER: 'CLIENT_COURSE_ORDER',
    CLIENT_CREDIT_ORDER: 'CLIENT_CREDIT_ORDER',
    ADD_CREDIT_BALANCE: 'ADD_CREDIT_BALANCE',
    ADD_PASS_BALANCE: 'ADD_PASS_BALANCE',
    CLIENT_PASS_ORDER: 'CLIENT_PASS_ORDER',
    CLIENT_ORDER_CANCELED: 'CLIENT_ORDER_CANCELED',
    CLIENT_ORDER_CANCELED_BY_STUDIO: 'CLIENT_ORDER_CANCELED_BY_STUDIO',
    CLIENT_ORDER_CANCELED_BY_STUDIO_DID_NOT_PAY: 'CLIENT_ORDER_CANCELED_BY_STUDIO_DID_NOT_PAY',
    CLIENT_ORDER_PAID: 'CLIENT_ORDER_PAID',
    CLIENT_ORDER_PAYMENT_FAILED: 'CLIENT_ORDER_PAYMENT_FAILED',
    CLIENT_ORDER_PAID_BY_STUDIO: 'CLIENT_ORDER_PAID_BY_STUDIO',
    CLIENT_CREDIT_ORDER_PAYMENT_CANCELED_FROM_OUTSIDE: 'CLIENT_CREDIT_ORDER_PAYMENT_CANCELED_FROM_OUTSIDE',
    CLIENT_PASS_ORDER_PAYMENT_CANCELED_FROM_OUTSIDE: 'CLIENT_PASS_ORDER_PAYMENT_CANCELED_FROM_OUTSIDE',
    CLIENT_COURSE_SESSION_CANCELED: 'CLIENT_COURSE_SESSION_CANCELED',
    CLIENT_VOUCHER_ORDER:'CLIENT_VOUCHER_ORDER',
    CLIENT_VOUCHER_CLAIM:'CLIENT_VOUCHER_CLAIM',
};
